import * as React from 'react';
import {
  Link,
  withRouter,
} from 'react-router-dom';

import { auth, db } from '../../firebase';
import * as routes from '../../constants/routes';
import '../../sass/Authentication.css';
import { FormGroup, FormControl, ControlLabel, HelpBlock, Button, Alert, Col, Glyphicon, Checkbox } from 'react-bootstrap';
import Logo from '../Logo';
import { SignInLink } from './SignIn';
import * as firebase from 'firebase/app'
import { FacebookLoginButton, GoogleLoginButton, createButton } from "react-social-login-buttons";
// const Mailchimp = require('mailchimp-api-v3'); 

// const MailchimpAPI = require('mailchimp-api-v3')
// const mc = new MailchimpAPI("18e92a4f8ede73114f3a7c002bf3194f-us19");

const SignUpPage = ({ history }) =>
<div id='signInModal' className='authModal'>
  <Logo/>
  <div>
    <h2>You</h2>
    <p className="signupIntro">Enter your details to begin your learning experience...</p>
    <SignUpForm history={history} />
    <SignInLink />
  </div>
</div>

const updateByPropertyName = (propertyName, value) => () => ({
  [propertyName]: value,
});

const INITIAL_STATE = {
  firstName: '',
  lastName: '',
  email: '',
  passwordOne: '',
  passwordTwo: '',
  error: null,
  termsAgreed: false,
  subscribeAgreed: false,
  termsError: null
};

class SignUpForm extends React.Component<any,any> {
  constructor(props) {
    super(props);

    this.handleFirstNameChange = this.handleFirstNameChange.bind(this);
    this.handleLastNameChange = this.handleLastNameChange.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handlePasswordOneChange = this.handlePasswordOneChange.bind(this);
    this.handlePasswordTwoChange = this.handlePasswordTwoChange.bind(this);
    this.handleTermsChange = this.handleTermsChange.bind(this);
    this.handleSubscribeChange = this.handleSubscribeChange.bind(this);

    this.state = { ...INITIAL_STATE, showEmailForm:false };
  }

  onSubmit = (event) => {
    event.preventDefault();
    const {
      firstName,
      lastName,
      email,
      passwordOne,
      termsAgreed,
      termsError,
    } = this.state;

    const {
      history,
    } = this.props;

    if (termsAgreed == true) {
      auth.doCreateUserWithEmailAndPassword(email, passwordOne)
      .then(authUser => {

        // Create a user in your own accessible Firebase Database too
        db.doCreateUser(authUser.user.uid, firstName, lastName, email)
          .then(() => {
            this.setState(() => ({ ...INITIAL_STATE }));
            history.push(routes.HOME);
          })
          .catch(error => {
            this.setState(updateByPropertyName('error', error));
          });

      })
      .catch(error => {
        this.setState(updateByPropertyName('error', error));
      });
      this.subscribe(email);
    } else {
      this.setState({termsError: "Please accept the terms and conditions"})
    }
    
  }

  private subscribe(emailAddress:string) {
    // Mailchimp.post('/lists/id/members', {
    //   email_address : emailAddress,
    //   status : 'subscribed',
    // })
    // .then(function(results) {
    //   console.log("Subscribe successful")
    // })
    // .catch(function (err) {
    //   console.log("Subscribe failed")
    // })
  }

  private handleGoogleAuth(e:any) {
    let provider = new firebase.auth.GoogleAuthProvider();
    this.handlePopupAuth(provider);
  }

  private handleFacebookAuth(e:any) {
    let provider = new firebase.auth.FacebookAuthProvider();
    this.handlePopupAuth(provider);
  }

  private handlePopupAuth(provider) {
    this.setState({loggingIn: true})
    const {
      history,
    } = this.props;
    auth.doSignInWithPopup(provider)
      .then((result) => {
        this.setState(() => ({ ...INITIAL_STATE }));
        history.push(routes.HOME);
        // console.log("Logged in: ", this.state.loggingIn, result.user.uid);
        let nameArray:Array<string> = result.user.displayName.split(" ");
        let firstName = nameArray[0];
        let lastName = nameArray[1];
        if (lastName == null) {lastName = ""}
        firebase.database().ref("users").child(result.user.uid).once('value', function(snapshot) {
          console.log('User exists: ', snapshot.exists());
          if (snapshot.exists() == false) {
            db.doCreateUser(result.user.uid, firstName, lastName, result.user.email)
          }
        });
      })
      .catch(error => {
        this.setState(updateByPropertyName('error', error));
        this.setState({loggingIn: false});
        // this.props.toggleLoggingIn(false);
      });
  }

  private handleFirstNameChange(e:any) {
    this.setState(updateByPropertyName('firstName', e.target.value));
  }

  private handleLastNameChange(e:any) {
    this.setState(updateByPropertyName('lastName', e.target.value));
  }

  private handleEmailChange(e:any) {
    this.setState(updateByPropertyName('email', e.target.value));
  }

  private handlePasswordOneChange(e:any) {
    this.setState(updateByPropertyName('passwordOne', e.target.value));
  }

  private handlePasswordTwoChange(e:any) {
    this.setState(updateByPropertyName('passwordTwo', e.target.value));
  }

  private handleTermsChange(e:any) {
    // console.log(e.target.checked)
    if (e.target.checked == true) {
      this.setState({termsAgreed: e.target.checked, termsError: null})
      return;
    }
    this.setState({termsAgreed: e.target.checked});
  }

  private handleSubscribeChange(e:any) {
    this.setState({subscribeAgreed: e.target.checked});
  }

  private signUpWithEmail() {
    this.setState({showEmailForm: true});
  }

  render() {
    const {
      firstName,
      lastName,
      email,
      passwordOne,
      passwordTwo,
      error,
      termsError,
    } = this.state;

    const isInvalid =
      passwordOne !== passwordTwo ||
      passwordOne === '' ||
      firstName === '' ||
      lastName === '' ||
      email === '';

    // const config = {
    //   text: "Sign Up",
    //   icon: "faIgloo",
    //   iconFormat: name => `fa fa-${name}`,
    //   style: { background: "#333" },
    //   activeStyle: { background: "#222" }
    // };
    // const EmailSignUpButton = createButton(config);

    return (
      <div>
        <Col className="socialLoginColumn" sm={12}>
          <div className="socialLoginButtons">
            <div className="socialLogin"><GoogleLoginButton text="Continue with Google" onClick={this.handleGoogleAuth.bind(this)} /></div>
            <div className="socialLogin"><FacebookLoginButton text="Continue with Facebook" onClick={this.handleFacebookAuth.bind(this)} /></div>
            {/* <div className="socialLogin"><EmailSignUpButton text="Sign up with email" onClick={this.handleFacebookAuth.bind(this)} /></div> */}
            {/* <Button className="emailLogin" onClick={this.signUpWithEmail.bind(this)}><Glyphicon glyph="envelope"/><p>Continue with email</p></Button> */}
          </div>
          <div id="or">OR</div>
          {
            error ?
            <Alert className="signUpAlert" bsStyle="danger">
            {error.message}
            </Alert> : null
          }
          {
            termsError ?
            <Alert className="signUpAlert" bsStyle="danger">
            {termsError}
            </Alert> : null
          }
        </Col>
        <form onSubmit={this.onSubmit}>

          <Col sm={6}>
            <FormGroup className='signInInput'>
                <FormControl
                  onChange={this.handleFirstNameChange}
                  value={firstName}
                  id="firstName"
                  type="text"
                  label="First name"
                  placeholder="First name" />
              {/* <HelpBlock>Enter your email address</HelpBlock> */}
            </FormGroup>
          </Col>
          <Col sm={6}>
            <FormGroup className='signInInput'>
                <FormControl
                  onChange={this.handleLastNameChange}
                  value={lastName}
                  id="lastName"
                  type="text"
                  label="Last name"
                  placeholder="Last name" />
              {/* <HelpBlock>Enter your email address</HelpBlock> */}
            </FormGroup>
          </Col>
          <Col sm={12}>
            <FormGroup className='signInInput'>
                <FormControl
                  onChange={this.handleEmailChange}
                  value={email}
                  id="email"
                  type="email"
                  label="Email"
                  placeholder="Email" />
              {/* <HelpBlock>Enter your email address</HelpBlock> */}
            </FormGroup>
            <FormGroup className='signInInput'>
                <FormControl
                  onChange={this.handlePasswordOneChange}
                  value={passwordOne}
                  id="passwordOne"
                  type="password"
                  label="Password"
                  placeholder="Password" />
              {/* <HelpBlock>Enter your email address</HelpBlock> */}
            </FormGroup>
            <FormGroup className='signInInput'>
                <FormControl
                  onChange={this.handlePasswordTwoChange}
                  value={passwordTwo}
                  id="passwordTwo"
                  type="password"
                  label="Password"
                  placeholder="Confirm password" />
              {/* <HelpBlock>Enter your email address</HelpBlock> */}
            </FormGroup>
            {/* <FormGroup>
                <Checkbox className="signUpCheckBox">I'm interested in finding out more about learning games and am happy to be contacted by the Serious Learning Games team.</Checkbox>
            </FormGroup> */}
            <FormGroup>
                <Checkbox onChange={this.handleTermsChange.bind(this)} className="signUpCheckBox">I have read and accept the <span className='link'><a target="_blank" href="https://app.termly.io/document/privacy-notice/e59f5b76-a4c6-4bdf-b86d-2d8be43b535b">Privacy Policy</a></span>.</Checkbox>
            </FormGroup>
            {/* <FormGroup>
                <Checkbox onChange={this.handleSubscribeChange.bind(this)} className="signUpCheckBox">I am happy to receive occasional emails from seriouslearninggames.com (you may unsubscribe at any time).</Checkbox>
            </FormGroup> */}
          </Col>
          <Button disabled={isInvalid} className="signInBtn mainBtn button-blue" type="submit">Submit</Button>
        </form>
      </div>
    );
  }
}

const SignUpLink = () =>
  <p>
    Don't have an account?
    {' '}
    <span className='link'><Link to={routes.SIGN_UP}>Sign Up</Link></span>
  </p>

export default withRouter(SignUpPage);

export {
  SignUpForm,
  SignUpLink,
};


// WEBPACK FOOTER //
// ./src/components/routes/SignUp.tsx